import Vue from 'vue'
import Router from 'vue-router'
import Header from '@/components/sub/Header'
import Footer from '@/components/sub/Footer'
import Login from "@/components/views/login/"
import Error from "@/components/views/login/error"
import Info from "@/components/views/login/info"
import ChangePw from "@/components/views/login/changePw"
import SecondVerify from "@/components/views/login/secondVerify"
import PrintMail from "@/components/views/login/mailPrint"
import AttachPreview from "@/components/views/login/attachPreview"
import Layout from "@/components/views/layout/"
import MainHome from "@/components/views/layout/MainHome"
import MainSetting from "@/components/views/layout/MainSetting"
// import Home from "@/components/Home"
import boxHome from "@/components/views/layout/boxHome"
import boxMail from "@/components/views/layout/boxMail"
import boxWrite from "@/components/views/layout/boxWrite"
import boxSent from "@/components/views/layout/boxSent"
import boxRead from "@/components/views/layout/boxRead"
import MainAddress from "@/components/views/layout/MainAddress"
import LargeAttach from "@/components/views/layout/largeAttach"
import userInfo from "@/components/views/setBox/userInfo"
import accountSecurity from "@/components/views/setBox/accountSecurity"
import changePassword from "@/components/views/setBox/changePassword"
import bindMobile from "@/components/views/setBox/bindMobile"
import unBindMobile from "@/components/views/setBox/unBindMobile"
import otherEmailAccount from "@/components/views/setBox/otherEmailAccount"
import addEmailAccount from "@/components/views/setBox/addEmailAccount"
import folderManage from "@/components/views/setBox/folderManage"
import AuditList from "@/components/views/setBox/auditList"
import blacklist from "@/components/views/setBox/blacklist"
import forwardReply from "@/components/views/setBox/forwardReply"
import forwardReplyLog from "@/components/views/setBox/forwardReplyLog"
import classificationRules from "@/components/views/setBox/classificationRules"
import addRules from "@/components/views/setBox/addRules"
import rulesLog from "@/components/views/setBox/rulesLog"
import strangeLoginLog from "@/components/views/setBox/strangeLoginLog"
import trustLocation from "@/components/views/setBox/trustLocation"
import generalSettings from "@/components/views/setBox/generalSettings"
import clientSetting from "@/components/views/setBox/clientSetting"
import signatureSetting from "@/components/views/setBox/signatureSetting"
import addSignature from "@/components/views/setBox/addSignature"
import antiSpamSetting from "@/components/views/setBox/antiSpamSetting"
import setComponent from "@/components/views/setBox/setComponent"

// import inBox from "@/components/views/inBox/inBox"
// import writeBox from "@/components/views/writeBox/writeBox"

import storeLocal from 'store';
import VueI18n from "vue-i18n"
import Cookies from 'js-cookie';
import {getConfigLanguage} from "@/utils/utils";
Vue.use(VueI18n);
Vue.use(Router)
Vue.use(Header)
Vue.use(Footer)

// 所有权限通用路由表,如首页和登录页和一些不用权限的公用页面
// export const constantRouterMap = [
//   {
//     path: '/login',
//     name: 'Login',
//     component: Login,
//   },
//   {
//     path: '/',
//     name: 'index',
//     component: index,
//     children: [
//       {
//         // path: '/views/inBox/inBox',
//         path: '/inBox',
//         name: 'inBox',
//         component: inBox,
//       },
//       {
//         // path: '/views/writeBox/writeBox',
//         path: '/writeBox',
//         name: 'writeBox',
//         component: writeBox,
//       },
//       // {
//       //   path: 'C',
//       //   name: 'C',
//       //   component: () => import('@/components/C')
//       // },
//     ]
//   },
//   {
//       path: '/',
//       name: 'Home',
//       component: Home,
//   },
//   {
//       // path: '/views/inBox/inBox',
//       path: '/inBox',
//       name: 'inBox',
//       component: inBox,
//   },
//   {
//       // path: '/views/writeBox/writeBox',
//       path: '/writeBox',
//       name: 'writeBox',
//       component: writeBox,
//   },
//   { path: '', redirect: "Home" }
// ]

// 定义挂载多语言文件
const configLanguage = getConfigLanguage();
const i18n = new VueI18n({
  locale: configLanguage || 'cn',
  messages: {
    cn: require("@/vueI18n/cn"),
    en: require("@/vueI18n/en"),
    hk: require("@/vueI18n/hk"),
  },
});

//根据后端config参数配置首页默认路由地址
// let configSetting = storeLocal.get('Pwm-configSetting');
// let loginRouterPath = '';
// try {
//   let loginRouterPage = configSetting ? configSetting.displaySetting.loginRouterPage : 1;
//   if(loginRouterPage === 1) {
//     loginRouterPath = '/home/info';
//   } else {
//     loginRouterPath = '/home/mail';
//   }
// } catch (e) {
//   console.log(e)
// }

export const routerMap = [
  {
    path: '/smailLogin',
    name: 'Login',
    component: Login,
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
  },
  {
    path: '/info',
    name: 'Info',
    component: Info
  },
  {
    path: '/changePw',
    name: 'ChangePw',
    component: ChangePw,
  },
  {
    path: '/secondVerify',
    name: 'SecondVerify',
    component: SecondVerify,
  },
  {
    path: '/printMail',
    name: 'PrintMail',
    component: PrintMail,
  },
  {
    path: '/attachPreview',
    name: 'AttachPreview',
    component: AttachPreview,
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    // meta: {keepAlive:true},
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: MainHome,
        // redirect: loginRouterPath,
        children: [
          {
            path: '/home/info',
            name: 'info',
            component: boxHome,
            meta: {title: i18n.t('router_title_001'), commonTab: true}
          },
          {
            path: '/home/mail',
            name: 'mail',
            component: boxMail,
            // meta: {keepAlive:true},
            redirect: '/home/mail/read',
            children: [
              {
                path: '/home/mail/read',
                name: 'read',
                // component: boxRead,
                meta: {title: i18n.t('router_title_002'), commonTab: true}
              }
            ]
          },
          {
            path: '/home/write',
            name: 'write',
            component: boxWrite,
            meta: {title: i18n.t('router_title_003'), writeTab: true}
          },
          {
            path: '/home/sent',
            name: 'sent',
            component: boxSent,
            meta: {title: i18n.t('router_title_004'), writeTab: true}
          },
          {
            path: '/home/read',
            name: 'newRead',
            component: boxMail,
            params: {},
            meta: {title: i18n.t('router_title_005'), newMoreOpen: true}
          },
          {
            path: '/largeAttach',
            name: 'largeAttach',
            component: LargeAttach,
            meta: {title: i18n.t('router_title_006'), commonTab: true}
          }
        ]
      },
      {
        path: '/setting',
        name: 'setting',
        component: MainSetting,
        // 重定向采用name  用于跳转传参
        redirect: {name: 'folderManage'},
        children: [
          {
            path: '/setting/userInfo',
            name: 'userInfo',
            component: userInfo,
            meta: {title: i18n.t('router_title_007'), commonTab: true}
          },
          {
            path: '/setting/accountSecurity',
            name: 'accountSecurity',
            component: accountSecurity,
            meta: {title: i18n.t('router_title_008'), commonTab: true}
          },
          {
            path: '/setting/strangeLoginLog',
            name: 'strangeLoginLog',
            component: strangeLoginLog,
            meta: {title: i18n.t('router_title_008')+'###'+i18n.t('router_title_009'), commonTab: true}
          },
          {
            path: '/setting/trustLocation',
            name: 'trustLocation',
            component: trustLocation,
            meta: {title: i18n.t('router_title_008')+'###'+i18n.t('router_title_010'), commonTab: true}
          },
          {
            path: '/setting/changePassword',
            name: 'changePassword',
            component: changePassword,
            meta: {title: i18n.t('router_title_008')+'###'+i18n.t('router_title_011'), commonTab: true}
          },
          {
            path: '/setting/bindMobile',
            name: 'bindMobile',
            component: bindMobile,
            meta: {title: i18n.t('router_title_008')+'###'+i18n.t('router_title_027'), commonTab: true}
          },
          {
            path: '/setting/unBindMobile',
            name: 'unBindMobile',
            component: unBindMobile,
            meta: {title: i18n.t('router_title_008')+'###'+i18n.t('router_title_028'), commonTab: true}
          },
          {
            path: '/setting/otherEmailAccount',
            name: 'otherEmailAccount',
            component: otherEmailAccount,
            meta: {title: i18n.t('router_title_012'), commonTab: true}
          },
          {
            path: '/setting/addEmailAccount',
            name: 'addEmailAccount',
            component: addEmailAccount,
            meta: {title: i18n.t('router_title_012')+'###'+i18n.t('router_title_013'), commonTab: true}
          },
          {
            path: '/setting/folderManage',
            name: 'folderManage',
            component: folderManage,
            meta: {title: i18n.t('router_title_014'), commonTab: true}
          },
          {
            path: '/setting/blacklist',
            name: 'blacklist',
            component: blacklist,
            meta: {title: i18n.t('router_title_015'), commonTab: true}
          },
          {
            path: '/setting/forwardReply',
            name: 'forwardReply',
            component: forwardReply,
            meta: {title: i18n.t('router_title_016'), commonTab: true}
          },
          {
            path: '/setting/forwardReplyLog',
            name: 'forwardReplyLog',
            component: forwardReplyLog,
            meta: {title: i18n.t('router_title_016')+'###'+i18n.t('router_title_017'), commonTab: true}
          },
          {
            path: '/setting/classificationRules',
            name: 'classificationRules',
            component: classificationRules,
            meta: {title: i18n.t('router_title_018'), commonTab: true}
          },
          {
            path: '/setting/addRules',
            name: 'addRules',
            component: addRules,
            meta: {title: i18n.t('router_title_018')+'###'+i18n.t('router_title_019'), commonTab: true}
          },
          {
            path: '/setting/rulesLog',
            name: 'rulesLog',
            component: rulesLog,
            meta: {title: i18n.t('router_title_018')+'###'+i18n.t('router_title_020'), commonTab: true}
          },
          {
            path: '/setting/generalSettings',
            name: 'generalSettings',
            component: generalSettings,
            meta: {title: i18n.t('router_title_021'), commonTab: true}
          },
          {
            path: '/setting/clientSetting',
            name: 'clientSetting',
            component: clientSetting,
            meta: {title: i18n.t('router_title_022'), commonTab: true}
          },
          {
            path: '/setting/signatureSetting',
            name: 'signatureSetting',
            component: signatureSetting,
            meta: {title: i18n.t('router_title_023'), commonTab: true}
          },
          {
            path: '/setting/addSignature',
            name: 'addSignature',
            component: addSignature,
            meta: {title: i18n.t('router_title_023')+'###'+i18n.t('router_title_024'), commonTab: true}
          },
          {
            path: '/setting/antiSpamSetting',
            name: 'antiSpamSetting',
            component: antiSpamSetting,
            meta: {title: i18n.t('router_title_025'), commonTab: true}
          },
          {
            path: '/setting/setComponent',
            name: 'setComponent',
            component: setComponent,
            meta: {title: '设置页面样例', commonTab: true}
          }
        ]
      },
      {
        path: '/address',
        name: 'address',
        component: MainAddress,
        meta: {title: i18n.t('router_title_026'), commonTab: true}
      }
    ]
  },
  {
    path: '/auditList',
    name: 'AuditList',
    component: AuditList
  }
]
// 实例化vue的时候只挂载constantRouter
export default new Router({
  mode: 'history', //后端支持可开
  // scrollBehavior: () => ({ y: 0 }),
  // routes: constantRouterMap
  routes: routerMap
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 异步挂载的路由,动态需要根据权限加载的路由表
export const asyncRouterMap = [

];



// WEBPACK FOOTER //
// ./src/router/index.js